import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const ComplaintsPolicy: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white pt-28">
            <div className="max-w-4xl mx-auto px-6 md:px-8 py-16">
                {/* Back Link */}
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-[#009B8F] hover:text-[#007d72] transition-colors mb-8 font-medium"
                >
                    <ArrowLeft size={18} />
                    Back to Home
                </Link>

                {/* Header */}
                <div className="mb-12">
                    <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#00151a] mb-4">
                        Complaints Policy
                    </h1>
                    <p className="text-slate-500 text-sm">Last updated: 1st March 2026</p>
                </div>

                {/* Content */}
                <div className="prose prose-slate max-w-none">
                    <div className="space-y-6 text-slate-700 leading-relaxed">
                        <p>
                            This Complaints Policy explains how Nex Overseas Ltd handles concerns or issues raised by users of our website and services. We aim to provide a professional, reliable, and supportive experience across all areas of our platform, including education consultancy, coaching and training, accommodation support, travel assistance, and our solicitor‑connection service. If something does not meet your expectations, we encourage you to let us know so we can address it promptly.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">How to Submit a Complaint</h2>
                        <p>
                            If you have a complaint about our services, you can contact us by email at <a href="mailto:info@nexoverseas.co.uk" className="text-[#009B8F] hover:underline">info@nexoverseas.co.uk</a>. Please include your name, the email address linked to your account, and a clear description of the issue. Providing screenshots or relevant details can help us understand the situation more quickly. We will review your complaint and aim to respond within a reasonable timeframe.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Third-Party Services</h2>
                        <p>
                            Complaints related to solicitor firms, universities, accommodation providers, or travel companies must be directed to those organisations directly, as they operate independently from us. Our role is limited to connecting you with these third parties if you request it. We are not responsible for their decisions, advice, or actions.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Technical Issues</h2>
                        <p>
                            If your complaint relates to a technical issue on our platform, we will investigate and resolve it as soon as possible. If the issue affects your ability to access a paid service, you may be eligible for support under our <Link to="/refund-policy" className="text-[#009B8F] hover:underline">Refund Policy</Link>. Complaints about dissatisfaction, change of mind, or comparisons with other organisations do not qualify for refunds.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Policy Updates</h2>
                        <p>
                            We may update this Complaints Policy from time to time. Any important changes will be communicated on our website. By using our services, you agree to the terms of this Policy.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplaintsPolicy;
